import { to } from "@lib/utils";
import { NFTReward, NFTRewardParam } from "@models/event/reward";
import { apiClient } from "@providers/auth";

export const getRewardByTransactionId = async (transactionId: string) => {
  const { res } = await to(
    apiClient.get(`/rewards?transactionId=${transactionId}`)
  );
  if (!res) return null;

  return new NFTReward(res as NFTRewardParam);
};
